import { Step } from 'react-joyride';

const getPurchasedVouchersTourSteps = (isMobile: boolean): Step[] => {
  const suffix = isMobile ? '-mobile' : '-desktop';

  const allSteps: (Step & { desktopOnly?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Bienvenido a <strong>Bonos vendidos</strong>. Aquí tienes el registro
          de todos los bonos que tus clientes han comprado, con su estado de
          uso, vencimiento y precio.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-filter-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa este buscador para <strong>filtrar los bonos vendidos</strong> por
          nombre del bono, servicio o cliente. Ideal para localizar rápido el
          bono de una persona concreta.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-sell-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa <strong>Vender bono</strong> para registrar una nueva venta:
          eliges el bono del catálogo y el cliente al que se lo vendes. A partir
          de ese momento podrá usarlo para pagar sus reservas.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-table-head',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Esta tabla muestra cada bono vendido: el cliente, su vencimiento, el
          precio y cuántos usos lleva consumidos.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: '.tour-usos-chart',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Este gráfico muestra los <strong>usos consumidos</strong> frente al
          total del bono (por ejemplo, 2/5). La parte azul es lo ya usado; así
          ves de un vistazo cuánto le queda al cliente.
        </div>
      ),
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: `.tour-delete-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          La <strong>papelera </strong> te permite eliminar un bono vendido,
          pero <strong>solo si el cliente aún no lo ha usado</strong> (0 usos).
          En cuanto tiene algún uso consumido deja de poder borrarse, para no
          perder el historial — verás la etiqueta <em>"No eliminable"</em> en su
          lugar.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si tienes muchos bonos vendidos, usa la <strong>paginación</strong>{' '}
          para moverte entre páginas y ajustar cuántos ver a la vez.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(isMobile && s.desktopOnly))
    .map(({ desktopOnly, ...step }) => step);
};

export default getPurchasedVouchersTourSteps;